'use client';
import React, { JSX, useState } from 'react';
import Image from 'next/image';
import LogoSVG from '../../public/logo.svg';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import { useCart } from '@/contexts/cart.context';
import { usePathname, useRouter } from 'next/navigation';
import { useSession } from '@/contexts/session.context';
interface HeaderProps {}

function PublicHeader({}: HeaderProps): JSX.Element {
  const { state } = useCart();
  const router = useRouter();
  const pathname = usePathname();

  const handleLogoClicked = () => {
    router.replace('/');
  };

  const isAdmin = useSession().user?.admin;

  return (
    <div className="navbar sticky top-0 bg-base-100 z-10 shadow-md">
      <div className="flex-1">
        {isAdmin && (
          <div className="flex justify-end mr-2">
            <button
              className="btn btn-sm btn-primary flex items-center"
              onClick={() => (window.location.href = '/admin')}
            >
              Admin
            </button>
          </div>
        )}
        <a className="cursor-pointer" onClick={handleLogoClicked}>
          <Image priority src={LogoSVG} alt="logo" width={100} height={50} />
        </a>{' '}
      </div>

      <div className="flex-none lg:hidden">
        {pathname !== '/login' && (
          <label
            htmlFor="cart-drawer"
            aria-label="close sidebar"
            className="btn btn-ghost"
          >
            <div className="indicator">
              {!!state.items.length && (
                <span className="indicator-item badge badge-primary px-1 badge-sm ">
                  {state.items.length}
                </span>
              )}
              <ShoppingCartIcon className="h-5 inline-block w-5" />
            </div>
          </label>
        )}
      </div>
    </div>
  );
}

export default PublicHeader;
